import Link from "next/link";
import useStore from "@store/index";

import styles from "@/styles/menu.module.scss"
import { Cart } from "@store/slices/orderActions";
import { encryptData, formatCurrency } from "_services/common.service";
import { Button } from "react-bootstrap";
import { X } from 'react-feather';

export default function FloatCart() {
    const { cart, cartItemsTotalCount }: { cart: Cart; cartItemsTotalCount: number; } = useStore((state) => state);

    const totalItemsWithQuantity = cart?.lineItems?.reduce((total, item) => total + (parseInt(item.quantity.toString() || '0')), 0) || 0;

    if (!cart || !cart.lineItems || cart.lineItems.length === 0) {
        return null; // Don't render if cart is empty
    }

    return (
        <div className={`${styles.cartFloat} animate__animated animate__bounceInUp`}>
            <span>{cartItemsTotalCount || totalItemsWithQuantity || 0} Items</span>
            <span className={styles.cartTotal}>{formatCurrency((cart.total?.amount || 0), (cart.total?.currency || "USD"))}</span>

            <Link id="float-cart-link" href={"/cart/?c="+encryptData(cart.orderId)}>
                <span className={styles.viewOrder}>View Order</span>
            </Link>

            <Button className={styles.closeButton} variant="default" size="sm" onClick={() => {
                const cartFloatElement = document.querySelector(`.${styles.cartFloat}`);
                if (cartFloatElement) {
                    cartFloatElement.classList.remove("animate__bounceInUp");
                    cartFloatElement.classList.add("animate__bounceOutDown");
                }
            }}>
                <X size={16} />
            </Button>
        </div>
    );
}